import type { Theme } from '@mui/material/styles';
import { styled } from '@mui/system';

export const SearchStartContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'animateIn',
})<{ animateIn?: boolean }>(({ theme, animateIn }) => ({
  width: '100%',
  maxWidth: '100%',
  backgroundColor: theme.palette.common.mds_global_color_white,
  boxSizing: 'border-box',
  opacity: animateIn ? 1 : 0,
  transition: 'opacity 200ms ease-out',
  willChange: 'opacity',
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
  },
  display: 'flex',
  height: '100dvh',
}));

export const SearchPageContainer = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'isNative' &&
    prop !== 'animateIn' &&
    prop !== 'isAutoComplete' &&
    prop !== 'disableScroll',
})<{
  isNative: boolean;
  animateIn?: boolean;
  keyboardBottomInset: number;
  isAutoComplete: boolean;
  disableScroll?: boolean;
}>(({ theme, isNative, animateIn, keyboardBottomInset, isAutoComplete, disableScroll }) => ({
  paddingBottom:
    keyboardBottomInset > 0
      ? `calc(${theme.spacing(2)} + ${keyboardBottomInset}px + env(safe-area-inset-bottom, 0px))`
      : isNative
        ? theme.spacing(7)
        : theme.spacing(0),
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
  marginTop: isNative ? theme.spacing(6) : 0,
  transform: animateIn ? 'translate3d(0, 0, 0)' : 'translate3d(0, 10px, 0)',
  transition: 'opacity 200ms ease-out, transform 200ms ease-out',
  willChange: 'opacity, transform',
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
    transform: 'none',
  },
  ...(disableScroll
    ? {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        height: '100vh',
        width: '100%',
        touchAction: 'none',
      }
    : {}),
  ...(isAutoComplete
    ? {
        overflow: 'hidden',
        overscrollBehavior: 'none',
        touchAction: 'none',
      }
    : {}),
  ...(!isAutoComplete && !disableScroll
    ? {
        overflowY: 'auto',
        overflowX: 'hidden',
        overscrollBehavior: 'contain',
      }
    : {}),
  overscrollBehavior: 'contain',
}));

export const SearchContentContainer = styled('div')(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));

export const BrandsSectionWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'minHeightPx',
})<{ minHeightPx?: number }>(({ minHeightPx }) => ({
  minHeight: minHeightPx ? `${minHeightPx}px` : undefined,
}));

export const TrendingSectionWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'minHeightPx',
})<{ minHeightPx?: number }>(({ minHeightPx }) => ({
  minHeight: minHeightPx ? `${minHeightPx}px` : undefined,
}));

export const RecommendationsSectionWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'minHeightPx',
})<{ minHeightPx?: number }>(({ minHeightPx }) => ({
  minHeight: minHeightPx ? `${minHeightPx}px` : undefined,
}));
interface SearchbarWrapperProps {
  isNative?: boolean;
}

export const SearchbarWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isNative',
})<SearchbarWrapperProps>(({ theme, isNative }) => ({
  paddingTop: isNative ? theme.spacing(1) : theme.spacing(2),
  paddingRight: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  width: '98%',
  touchAction: 'none',
  position: 'fixed',
  backgroundColor: theme.palette.common.mds_global_color_white,
  zIndex: 1000,
}));

export const IconButtonPlainStyle: React.CSSProperties = {
  marginLeft: '8px',
  marginRight: '8px',
  border: '1px solid #D4D4D8',
};

export const BackButtonSx = (theme: Theme): React.CSSProperties => ({
  color: theme.palette.common.mds_global_color_black_1,
});
